export const GET_ADMIN_DASHBOARD_REQUEST = 'GET_ADMIN_DASHBOARD_REQUEST';
export const GET_ADMIN_DASHBOARD_SUCCESS = 'GET_ADMIN_DASHBOARD_SUCCESS';
export const GET_ADMIN_DASHBOARD_FAILURE = 'GET_ADMIN_DASHBOARD_FAILURE';
export const CLEAR_DASHBOARD_DATA = 'CLEAR_DASHBOARD_DATA';